import React, { useState } from "react";
import CardImg from "../../../../components/CardImg";

const IMG = `${import.meta.env.BASE_URL}img/cards`;

/**
 * 1 CARD ONE-DAY (teen1) card overlay for VideoBox — reference markup:
 * .casino-video-cards[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container
 *   (div > .dealer-name "Player" + card, div > .dealer-name "Dealer" + card). Styled by index.css.
 * Like the reference: hidden while the first card is a back ("1"); the shuffle handle toggles it.
 */
export default function Teen1CardsOverlay({ card }) {
  const [showCards, setShowCards] = useState(true);
  const cards = String(card ?? "").split(",").map((c) => c.trim());
  if (!String(card ?? "").length) return null;
  const hidden = !showCards || cards[0] === "1";

  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  const side = (name, c) => (
    <div>
      <div className="dealer-name w-100 mb-1">{name}</div>{" "}
      <div>
        <span>
          <span>
            <CardImg src={`${IMG}/${c ?? "1"}.png`} alt="" />
          </span>
        </span>
      </div>
    </div>
  );

  return (
    <div className={`casino-video-cards${hidden ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        {side("Player", cards[0])} {side("Dealer", cards[1])}
      </div>
    </div>
  );
}
